import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CustomerLegalState {
  termsOfUse: string;
  privacyPolicy: string;
  emailVerificationAcceptedTitle: string;
  emailVerificationAcceptedFromName: string;
  emailVerificationAcceptedContent: string;
  emailVerificationCompletedTitle: string;
  emailVerificationCompletedFromName: string;
  emailVerificationCompletedContent: string;
  isLoading: boolean;
  error: string | null;
}

const initialState: CustomerLegalState = {
  termsOfUse: '',
  privacyPolicy: '',
  emailVerificationAcceptedTitle: '',
  emailVerificationAcceptedFromName: '',
  emailVerificationAcceptedContent: '',
  emailVerificationCompletedTitle: '',
  emailVerificationCompletedFromName: '',
  emailVerificationCompletedContent: '',
  isLoading: false,
  error: null,
};

const customerLegalSlice = createSlice({
  name: 'customerLegal',
  initialState,
  reducers: {
    setCustomerLegal: (state, action: PayloadAction<Partial<CustomerLegalState>>) => {
      return { ...state, ...action.payload };
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const { setCustomerLegal, setLoading, setError, clearError } = customerLegalSlice.actions;
export default customerLegalSlice.reducer;
